import { useDropzone } from 'react-dropzone'
import { useProject } from 'contexts/ProjectContext'
import { request } from 'hooks/useApi'

export default function useS3Upload({
  presignedUploadUrl,
  onUploadStart,
  onUploadReady,
  onError,
  disabled,
  name,
  accept = 'image/*',
}) {
  const { project } = useProject()

  async function onDrop([pendingFile], _, event) {
    if (event) {
      event.stopPropagation()
    }

    // Let the caller know that a file has been selected and a fetch is beginning.
    onUploadStart()

    const url =
      presignedUploadUrl ||
      (await request(
        `/rest/v2/project/${project.id}/upload?name=${encodeURIComponent(pendingFile.name)}`
      ))

    // Upload the file to our pre-signed URL.
    const response = await fetch(
      new Request(url, {
        method: 'PUT',
        body: pendingFile,
        headers: new Headers({
          'Content-Type': pendingFile.type
        }),
      })
    )
    if (response.status !== 200) {
      // The upload failed, so let's notify the caller.
      onError()
      return
    }
    // Let the caller know that the upload is done, so that it can send the URL
    // to the backend again, persisting it to the database.
    onUploadReady(url, pendingFile)
  }

  return useDropzone({
    accept,
    disabled,
    onDrop,
  })
}
